// import PropTypes from 'prop-types';
// import { Avatar, Box ,ButtonBase} from '@mui/material'
// import React from 'react'
// import { IconMenu2 } from '@tabler/icons';
// import { useTheme } from '@mui/material/styles';
// const Header = ({handleLeftDrawerToggle}) => {
//     const theme = useTheme();
//     return (
//         <Box sx={{ width: "100%", height: "20px", backgroundColor: "#3538CD" }}>
//               <Box
//                 sx={{
//                     width: "100%",
//                     display: 'flex',
//                     [theme.breakpoints.down('md')]: {
//                         width: 'auto'
//                     },
//                 }}
//             >
//   <ButtonBase sx={{ borderRadius: '12px',  }}>
//                     <Avatar
//                         variant="rounded"
//                         sx={{
//                             ...theme.typography.commonAvatar,
//                             ...theme.typography.mediumAvatar,
//                             transition: 'all .2s ease-in-out',
//                             background: theme.palette.background.paper,
//                             color: theme.palette.secondary.dark,
//                             '&:hover': {
//                                 background: theme.palette.secondary.dark,
//                                 color: theme.palette.secondary.light
//                             }
//                         }}
//                         onClick={handleLeftDrawerToggle}
//                         color="inherit"
//                     >
//                         <IconMenu2 stroke={1.5} size="1.3rem" />
//                     </Avatar>
//                 </ButtonBase>
//         </Box>
//         </Box>
//     )
// }
// Header.propTypes = {
//     handleLeftDrawerToggle: PropTypes.func
// };
// export default Header
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, IconButton } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import Initial from 'helpers/Initial';

// assets
import { IconMenu2 } from '@tabler/icons';
import { useSelector } from 'react-redux';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const leftDrawerOpened = useSelector((state) => state.customization.opened);
  return (
    <>
      <Box sx={{ width: "100%", height: "20px", backgroundColor: "#3538CD" }}>
        {/* logo & toggler button */}
        <Box
          sx={{
            width: "8.8%",
            display: 'flex',
            height: "18px",
            // height:100,
            // backgroundColor: "#3538CD",
            display: "flex",
            justifyContent: 'center',
            [theme.breakpoints.down('md')]: {
              width: 'auto'
            },
          }}
        >
          {/* <Box component="span" sx={{ display: { xs: 'none', md: 'flex' }, flex: 1, alignItems:'center'}}> */}
          {/* <LogoSection /> */}
          {/* </Box> */}
          {/* <ButtonBase sx={{ borderRadius: '12px',  justifyContent:"flex-start", marginLeft:"90px", overflow: 'hidden', display: { xs: 'none', md: 'flex' }, flex: 1,   }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.dark,
                            color: theme.palette.secondary.light,
                            width:"20px", 
                            // color: "#fff",
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase> */}

        </Box>

        {/* header search */}
        <SearchSection />
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ flexGrow: 1 }} />

        {/* notification & profile */}
        {/* <NotificationSection /> */}
        {/* <ProfileSection /> */}
      </Box>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;